module.exports = __webpack_public_path__ + "static/wpack/extracted/winner-icond043db15b5b00489131e35fd7b132646.svg";